<mat-dialog-content class="mat-typography">
  <section class="add-items-dialog-wrapper">
    <h2 class="cmn-popup-title">Choose task variant</h2>
    <button class="cmn-close" mat-dialog-close></button>

    <form
      [formGroup]="itemGroup"
      (ngSubmit)="onSubmit()"
      (keydown)="preventEnterKey($event)"
    >
      <div class="item-service-adding-table-wrapper" formArrayName="variants">
        <div>
          <div class="form-container">
            <div
              class="form-grid-wrapper"
              *ngFor="let group of variants.controls; let i = index"
              [formGroupName]="i"
            >
              <div>
                <span>Task</span>
                <mat-form-field appearance="fill">
                  <input
                    matInput
                    placeholder="Task Name"
                    formControlName="taskName"
                    readonly
                  />
                </mat-form-field>
              </div>
              <div>
                <span>Variants</span>
                <mat-form-field appearance="fill">
                  <mat-select
                    placeholder="Select Task Variant"
                    formControlName="taskVariantId"
                    (selectionChange)="onVariantSelected(i)"
                  >
                    <mat-option
                      *ngFor="let v of group.get('variants')?.value"
                      [value]="v.id"
                    >
                      {{ v.variantName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div>
                <span>Price</span>
                <mat-form-field appearance="fill">
                  <input
                    matInput
                    type="number"
                    placeholder="Price"
                    formControlName="price"
                    readonly
                  />
                </mat-form-field>
              </div>
              <div>
                <span>ETA</span>
                <mat-form-field appearance="fill">
                  <input
                    matInput
                    placeholder="ETA"
                    formControlName="eta"
                    readonly
                  />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <button class="cmn-next-btn" type="button" (click)="onSubmit()">
          Submit
        </button>
      </div>
    </form>
  </section>
</mat-dialog-content>
